module.exports = __webpack_public_path__ + "img/icon-case-info.a41e1345.svg";